Controller = App.loadClass 'core::Angular/Controller'

class exports.IrrigationSettings2Controller extends Controller

    constructor: (@scope, @transitions, @zone_type, option_name, option_type, options, @validation, @pgis, @zones_service) ->

        # prevent errors when refreshing or navigating directly to this step
        if not @pgis.field_data? and not @validation.canContinue()
            return

        @scope.disabled.back = false
        # location of field data may change depending on entry point
        @scope.field_data = if @pgis?.field_data? then @pgis.field_data else @validation.getFieldData()
        @scope.zone = @scope.field_data.zones[@zone_type]
        @scope.zone.zone_type = @zone_type
        @scope.zone_type = @zone_type
        @scope.selected = { crop: null }
        # set flag
        @scope.field_data.visited_settings = true
        @scope.allowed_crops = ['Corn (grain)', 'Soybeans', 'Wheat', 'Cotton']
        @scope.crops = ['Corn (grain)', 'Soybeans', 'Wheat', 'Cotton']
        @scope.all_crops_added = false
        @scope.crop_ranges = @makeCropRanges()
        @scope.used_for_fertilizer = false
        @scope.adding_crop = false
        @scope.rows = []
        @loadRows()

        # setup validation
        @scope.validation = @validation
        @scope.validate = @validate
        @scope.validation.setStepScope(@scope)
        @scope.addCrop = @addCrop
        @scope.addRow = @addRow
        @scope.constrainRow = @constrainRow
        @scope.deleteRow = @deleteRow

        @showOnMap(@scope.field_data.zones.irrigation)

        @scope.$watchCollection () =>
            return (row.crop for row in @scope.rows)
        , (vals, old) =>
            # only allow the user to add values for each crop once
            @scope.crops = (crop for crop in @scope.allowed_crops when crop not in vals)

        @scope.$watch 'crops.length', (val, old) =>
            @scope.all_crops_added = val is 0

        @transitionStart = @transitions.onStart {}, ($transition) =>
            @pgis.setIrrigationZone(@scope.zone)

            if _.startsWith($transition.to().name, 'grower.fields-define')
                @scope.died_willingly = true

        @scope.$parent.steps.once 'switch-from', "grower.fields-define.#{@zone_type}-settings1", (data) =>
            if data.is_forward
                # reset it for the next zone
                @scope.field_data.visited_settings = null
                @validation.setFieldData(@scope.field_data)

        @scope.$on '$destroy', () =>
            if not @scope.died_willingly
                # clear layers
                @validation.clearLayers()
                # clear settings
                @validation.settings = {}

            for area in @scope.field_data.zones.irrigation.zones
                App.map.removeLayer area.visible

            @transitionStart()

        @scope.validation.validate()
        @validation.setBackButtonDisable(@scope.field_data, 'add-crop')

    validate: (ending) =>
        # ensure that each input has a value selected
        @validation.setFieldData(@scope.field_data)

        # ensure that we have rows
        return false if not @scope.rows.length

        # ensure that all rows have required values selected
        for row in @scope.rows
            if not row.crop or not row.irrigated_range?.min or not row.dryland_range?.min
                return false

        # ensure we aren't in the middle of adding a crop
        return false if @scope.adding_crop

        # update the layer using information from this step
        @scope.field_data.zones.irrigation.extra_info = @makeExtraInfo()

        return true

    loadRows: () =>
        # first try to load rows for an existing zone
        if @scope.field_data.zones.irrigation.extra_info?.crops?
            for crop in @scope.field_data.zones.irrigation.extra_info.crops
                row = @scope.field_data.zones.irrigation.extra_info.mappings[crop]
                row.crop = crop
                @scope.rows.push row

        if @scope.field_data.zones.irrigation.extra_info?.used_for_fertilizer?
            @scope.used_for_fertilizer = @scope.field_data.zones.irrigation.extra_info.used_for_fertilizer

        # see if we need to add an additional row for special cases (like fieldprint)
        if @validation.settings?.crop? and @validation.settings?.crop not in (row.crop for row in @scope.rows)
            @scope.rows.push { irrigated_range: null, dryland_range: null, crop: @validation.settings.crop, deletable: false, has_fieldprint: true, has_rx: false }

        if @scope.field_data.process_mode is 'add-crop'
            # we need to do this here since its usually done in a prior step that is skipped as part of the add-crop process flow
            @convertSavedZones()
        # we want to default to the "adding crop" state if we don't already have at least one row
        @scope.adding_crop = true if not @scope.rows.length

    constrainRow: (row, irrigated_changed) =>
        if irrigated_changed
            # the irrigated value is the one that changed
            if row.dryland_range?.min >= row.irrigated_range?.min
                # set dryland to the option just lower than the current irrigated option
                row.dryland_range = @scope.crop_ranges[row.crop]['Dryland'].find((element) =>
                    return element.min is row.irrigated_range.max
                )
        else
            if row.dryland_range?.min >= row.irrigated_range.min
                # set irrigated to the option just higher than the current dryland option
                row.irrigated_range = @scope.crop_ranges[row.crop]['Irrigated'].find((element) =>
                    return element.max is row.dryland_range.min
                )
    addCrop: () =>
        @scope.adding_crop = true

    addRow: () =>
        @scope.rows.push { crop: @scope.selected.crop, irrigated_range: null, dryland_range: null, deletable: true, has_fieldprint: false, has_rx: false }
        @scope.selected.crop = null
        @scope.adding_crop = false


    makeCropRanges: () =>
        return {
            'Corn (grain)': @makeRanges(x for x in [360..0] by -20)
            Soybeans: @makeRanges(x for x in [120..0] by -5)
            Wheat: @makeRanges(x for x in [120..0] by -5)
            Cotton: @makeRanges(x for x in [3000..400] by -200, 'lbs/ac')
        }

    makeRanges: (values, units = 'bu/ac') =>
        ranges = []

        for value, index in values when index < values.length - 1
            ranges.push {
                text: "#{values[index + 1]}-#{value} #{units}"
                value: "#{values[index + 1]}-#{value}"
                min: value
                max: values[index + 1]
                units: units
            }

        ranges.sort((a, b) ->
            return b.min - a.min
        )

        # give irrigated ranges one range higher than the highest dryland range, and dryland ranges one range lower than the lowest irrigated range
        return {
            'Irrigated': (range for range, index in ranges when index isnt ranges.length - 1),
            'Dryland': (range for range, index in ranges when index isnt 0)
        }

    makeExtraInfo: () =>
        extra_info = {
            # we cannot delete the management zone if any of the rows cannot be deleted
            deletable: false not in (row.deletable for row in @scope.rows)
            used_for_fertilizer: @scope.used_for_fertilizer
            crops: (row.crop for row in @scope.rows)
            mappings: @makeMappings()
        }

    makeMappings: () =>
        mappings = {}

        for row in @scope.rows
            mappings[row.crop] = { irrigated_range: row.irrigated_range, dryland_range: row.dryland_range, units: row.units, deletable: row.deletable }

        return mappings

    deleteRow: (row) =>
        @scope.rows = @scope.rows.filter((element) =>
            return element.crop isnt row.crop
        )

    showOnMap: (zones) =>
        for area in zones.zones
            geojson = area.visible.toGeoJSON()

            area.visible.clearLayers()

            # set layer styles
            L.geoJson(geojson).eachLayer (l) =>
                l.setStyle({ weight: 2, color: area.color, fillOpacity: 0.6 })
                area.visible.addLayer(l)
                @validation.pgis.added_layers.push l

            # add to map
            area.visible.addTo App.map

    convertSavedZones: () =>
        for area, index in @scope.field_data.zones.irrigation.loaded_zones

            # Since add-crop state can call this method many times (by flipping between the this step and the next step) we should
            # only let the method run once. We don't want to keep adding loaded_zones to irrigation.zones
            if @scope.field_data.zones.irrigation.zones.filter((z) -> z.id is area.id).length
                continue

            area.settings = {}
            area.visible = new L.FeatureGroup()
            area.unclipped = new L.FeatureGroup()
            area.color = @zones_service.getNextColor(null, index)
            area.identity = area.id

            # translate the geojson to leaflet
            style = @zones_service.defaultZoneStyle(area.color)
            zone = _.clone(area)

            # set the leaflet geoms in visible
            L.geoJson(zone.geometry).eachLayer (layer) =>
                # 'set style on l of combined'
                layer.setStyle(style ? {})
                # add layer to the front end
                zone.visible.addLayer(layer)
                zone.unclipped.addLayer(layer)
                @pgis.added_layers.push
                zone.visible.addTo(App.map)

            # create a new zone object and push it
            zone = @zones_service.setZoneArea(zone)
            zone.extra_info = JSON.parse(zone.extra_info) if zone?.extra_info?

            @scope.field_data.zones.irrigation.zones.push zone
